export default ($axios) => ({
  async getAll(organizationId) {
    return $axios.get(`/organization/${organizationId}/admin/settings`);
  },
  async update(organizationId, data) {
    return $axios.post(`/organization/${organizationId}/admin/settings`, data);
  },
})
